import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { shallowEqual, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { RootState } from "typedefs";
import { isAcademyOnboardingCoach } from "app/utils/subscription";
import useAcademySetupItems from "app/utils/hooks/useAcademySetupItems";
import {
  AcademySetupLocationState,
  allComplete,
  completedCount,
} from "../items";
import {
  dismissSetupRail,
  leaveSetupRail,
  railLocationKey,
} from "../SetupToast";
import styles from "./styles.module.scss";

const SidebarBadge = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation();
  const { self } = useSelector((state: RootState) => state.user, shallowEqual);
  const { items, loaded } = useAcademySetupItems();

  // The setup rail auto-dismisses on navigation; the badge is mounted on every
  // page. Query and hash count: a Billing tab switch leaves the view too.
  useEffect(() => {
    leaveSetupRail(railLocationKey(location));
  }, [location.pathname, location.search, location.hash]);
  // The badge lives in SiteWrapper, so its unmount means the app chrome is
  // going away (sign-out, a takeover route): the rail must not outlive it.
  useEffect(() => dismissSetupRail, []);

  if (!isAcademyOnboardingCoach(self)) {
    return null;
  }

  if (!loaded || allComplete(items)) {
    return null;
  }

  const onClick = () => {
    const state: AcademySetupLocationState = { setupEntryPoint: "sidebar_pill" };
    history.push("/academy/setup", state);
  };

  return (
    <button
      type="button"
      className={styles.badge}
      onClick={onClick}
      data-testid="sidebar-academy-setup-badge"
    >
      <span>{t("Academy setup")}</span>
      <span>
        {completedCount(items)}/{items.length}
      </span>
    </button>
  );
};

export default SidebarBadge;
